import { useState } from 'react';
import { useLocation } from 'wouter';
import { useGame } from '../state/GameContext.jsx';
import { useNoScroll } from '../hooks/useNoScroll.js';

const EMOJIS = ['😀','😎','🤩','😜','🥳','🤔','😤','🥸','🐱','🐶','🦊','🐸','🐼','🦁','🐯','🐻','🍎','🍕','🍜','🎮','⚽','🎸','🌈','⚡','🔥','💎','🎯','🚀'];

export default function PlayerJoinScreen() {
  useNoScroll();
  const [, setLocation] = useLocation();
  const { connect, dispatch, ROOM_WORKER_URL } = useGame();

  const [roomCode, setRoomCode] = useState('');
  const [nickname, setNickname] = useState('');
  const [emoji, setEmoji] = useState('😀');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async () => {
    const code = roomCode.trim().toUpperCase();
    if (!code || !nickname.trim()) {
      setError('ルームコードとニックネームを入力してください');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const deviceId = localStorage.getItem('saiten-man-device-id') || (() => {
        const id = crypto.randomUUID();
        localStorage.setItem('saiten-man-device-id', id);
        return id;
      })();

      const res = await fetch(`${ROOM_WORKER_URL}/api/room/${code}/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname: nickname.trim(), emoji, deviceId }),
      });
      if (!res.ok) {
        const { error: e } = await res.json().catch(() => ({ error: '接続エラー' }));
        setError(e || '参加に失敗しました');
        setLoading(false);
        return;
      }
      const { participantId, participantToken } = await res.json();
      dispatch({ type: 'SET_SESSION', payload: { role: 'participant', roomCode: code } });
      connect(code, participantId, participantToken);
      setLocation('/play');
    } catch {
      setError('サーバーに接続できませんでした');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen tv-bg-stripe flex flex-col items-center p-6 gap-5 overflow-y-auto">
      <button className="self-start tv-btn tv-btn-white text-sm px-3 py-1 mt-2" onClick={() => setLocation('/')}>
        ← 戻る
      </button>

      <h2 className="tv-heading text-3xl">参加する</h2>

      <div className="tv-panel w-full max-w-xs p-5 flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <label className="font-body text-sm font-bold">ルームコード</label>
          <input
            type="text"
            maxLength={6}
            placeholder="例: AB3X7K"
            value={roomCode}
            onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
            className="border-4 border-tv-sumi rounded-tv px-3 py-2 font-num text-xl tracking-widest uppercase text-center focus:outline-none focus:border-tv-yellow"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="font-body text-sm font-bold">ニックネーム</label>
          <input
            type="text"
            maxLength={20}
            placeholder="あなたの名前"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            className="border-4 border-tv-sumi rounded-tv px-3 py-2 font-body text-base focus:outline-none focus:border-tv-yellow"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="font-body text-sm font-bold">絵文字を選ぶ</label>
          <div className="grid grid-cols-7 gap-1">
            {EMOJIS.map((e) => (
              <button
                key={e}
                onClick={() => setEmoji(e)}
                className={`text-2xl p-1 rounded-lg border-2 ${emoji === e ? 'border-tv-yellow bg-yellow-50' : 'border-transparent'}`}
              >
                {e}
              </button>
            ))}
          </div>
        </div>

        {error && <p className="text-tv-red font-body text-sm text-center">{error}</p>}

        <button
          className="tv-btn tv-btn-blue text-lg py-3"
          onClick={handleJoin}
          disabled={loading}
        >
          {loading ? '参加中…' : '参加する！'}
        </button>
      </div>
    </div>
  );
}
